import Layout from "../views/layout/index.vue";
import NewLayout from "../views/newLayout/index.vue";
import countryLayout from "../views/newLayout/index.vue";
import VueRouter from "vue-router";
const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "home",
    component: () => import("../views/home/index.vue"),
  },

  {
    path: "/csiApp",
    name: "csiApp",
    component: () => import("../views/csiApp/csiApp.vue"),
  },
  {
    path: "/whatIsNew",
    name: "whatIsNew",
    component: () => import("../views/whatIsnews/index.vue"),
  },
  {
    path: "/csiPhone",
    name: "csiPhone",
    component: () => import("../views/csiApp/csiPhone.vue"),
  },
  {
    path: "/privacypolicy",
    name: "privacypolicy",
    component: () => import("../views/csiApp/privacypolicy.vue"),
  },

  {
    path: "/index",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "list",
        component: () => import("../views/company/list.vue"),
        name: "companyList",
        meta: { title: "企业列表", activeMenu: "/system/role" },
        children: [
          {
            path: "company",
            name: "companyNoParams",
            component: () => import("../views/company/list/company.vue"),
          },
          {
            path: "risk",
            name: "riskNoParams",
            component: () => import("../views/company/list/risk.vue"),
          },
        ],
      },
      // 风险扫描
      {
        path: "riskScan",
        name: "riskScanDetail",
        component: () => import("../views/RiskScan/index.vue"),
      },
      {
        path: "search/list/:search",
        component: () => import("../views/company/list.vue"),
        name: "companyListSearch",
        meta: { title: "企业列表", activeMenu: "/system/role" },
        children: [
          {
            path: "company",
            name: "companylistSearch",
            meta: { title: "companyListSearch" },
            component: () => import("../views/company/list/company.vue"),
          },
          {
            path: "risk",
            name: "risklist",
            component: () => import("../views/company/list/risk.vue"),
          },
        ],
      },
      // 获课
      {
        path: "risk/details/:search",
        component: () => import("../views/company/list.vue"),
        name: "riskDeatailsP",
        children: [
          {
            name: "riskdetailsC",
            path: "riskdetails",
            component: () => import("../views/company/details/Risk/risk.vue"),
          },
        ],
      },
      // 贸易公司详情
      {
        path: "tradeCompany/Trade/:id",
        component: () => import("../views/company/TradeDetail.vue"),
        name: "TradeDetails",
        meta: { title: "TradeDetails" },
        children: [
          // background部分
          {
            name: "tradeMap",
            path: "tradeMap/map",
            meta: { title: "TradeDetails" },
            component: () => import("../views/company/Trade/tradeMap/map.vue"),
          },
          {
            name: "supplyChain",
            path: "supplyChain/index",
            meta: { title: "TradeDetails" },
            component: () =>
              import("../views/company/Trade/SupplyChain/indextwo.vue"),
          },
          {
            name: "competitiveness",
            path: "competitiveness/index",
            meta: { title: "TradeDetails" },
            component: () =>
              import("../views/company/Trade/Competitiveness/index.vue"),
          },
          {
            name: "shippingOverview",
            path: "shippingOverview/index",
            meta: { title: "TradeDetails" },
            component: () =>
              import("../views/company/Trade/ShippingOverview/indextwo.vue"),
          },
          {
            name: "shippingOverviewDetailsenterprises&Export",
            path: "shippingOverview/importDetailCompany",
            meta: { title: "TradeDetails" },
            component: () =>
              import(
                "../views/company/Trade/ShippingOverview/importDetailCompany.vue"
              ),
          },
          {
            name: "shippingOverviewDetailCompany",
            path: "shippingOverview/DetailCompany",
            meta: { title: "TradeDetails" },
            component: () => import("../views/company/Trade/DetailCompany.vue"),
          },
          {
            name: "countries",
            path: "countries/index",
            meta: { title: "TradeDetails" },
            component: () =>
              import("../views/company/Trade/Countries/indextwo.vue"),
          },
          {
            name: "countries",
            path: "countries/importDetailProduct",
            meta: { title: "TradeDetails" },
            component: () =>
              import(
                "../views/company/Trade/ShippingOverview/importDetailCompany.vue"
              ),
          },
          ,
          {
            name: "countries",
            path: "countries/Detail",
            meta: { title: "TradeDetails" },
            component: () => import("../views/company/Trade/DetailCountry.vue"),
          },
          {
            name: "partners",
            path: "partners/index",
            meta: { title: "TradeDetails" },
            component: () =>
              import("../views/company/Trade/Partners/index.vue"),
          },
          {
            name: "products",
            path: "products/index",
            meta: { title: "TradeDetails" },
            component: () =>
              import("../views/company/Trade/products/indextwo.vue"),
          },
          {
            name: "products",
            path: "products/Detail",
            meta: { title: "TradeDetails" },
            component: () => import("../views/company/Trade/DetailProuct.vue"),
          },
          {
            name: "products",
            path: "products/importDetailCompany",
            meta: { title: "TradeDetails" },
            component: () =>
              import(
                "../views/company/Trade/ShippingOverview/importDetailCompany.vue"
              ),
          },
          {
            name: "tradeTrends",
            path: "tradeTrends/index",
            meta: { title: "TradeDetails" },
            component: () =>
              import("../views/company/Trade/TradeTrends/index.vue"),
          },

          // creditOpinion 模块

          {
            name: "creditOpinion",
            path: "creditOpinion/list",
            meta: { title: "TradeDetails" },
            component: () =>
              import("../views/company/Trade/CreditOpinion/list.vue"),
          },
          // Market Analysis模块
        ],
      },
      // 贸易产品详情
      {
        path: "TradeProduct/TradeDetail/:id",
        component: () => import("../views/company/TradeProductDetail.vue"),
        name: "TradeProductDetails",
        meta: { title: "TradeProductDetails" },
        children: [
          // background部分
          {
            name: "TradeProductDetailstradeMap",
            path: "tradeMap/map",
            meta: { title: "TradeProductDetails" },
            component: () =>
              import("../views/company/TradeProduct/tradeMap/map.vue"),
          },
          {
            name: "TradeProductDetailssupplyChain",
            path: "supplyChain/index",
            meta: { title: "TradeProductDetails" },
            component: () =>
              import("../views/company/TradeProduct/SupplyChain/indextwo.vue"),
          },
          {
            name: "TradeProductDetailscompetitiveness",
            path: "competitiveness/index",
            meta: { title: "TradeProductDetails" },
            component: () =>
              import("../views/company/TradeProduct/Competitiveness/index.vue"),
          },
          {
            name: "TradeProductDetailsshippingOverview",
            path: "shippingOverview/index",
            meta: { title: "TradeProductDetails" },
            component: () =>
              import(
                "../views/company/TradeProduct/ShippingOverview/indextwo.vue"
              ),
          },
          {
            name: "TradeProductDetailsshippingOverviewDetailsenterprises&Export",
            path: "shippingOverview/importDetailProduct",
            meta: { title: "TradeProductDetails" },
            component: () =>
              import(
                "../views/company/TradeProduct/ShippingOverview/importDetailProduct.vue"
              ),
          },
          {
            name: "TradeProductDetailsoriginDestination",
            path: "origin&Destination/Detail",
            meta: { title: "TradeProductDetails" },
            component: () =>
              import("../views/company/TradeProduct/DetailCountry.vue"),
          },
          {
            name: "TradeProductDetailsoriginDestinationDetailsenterprises&Export",
            path: "origin&Destination/importDetailProduct",
            meta: { title: "TradeProductDetails" },
            component: () =>
              import(
                "../views/company/TradeProduct/ShippingOverview/importDetailProduct.vue"
              ),
          },

          {
            name: "TradeProductDetailsshippingOverviewDetail",
            path: "shippingOverview/DetailCompany",
            meta: { title: "TradeProductDetails" },
            component: () =>
              import("../views/company/TradeProduct/DetailCompany.vue"),
          },

          {
            name: "TradeProductDetailsorigin&Destination",
            path: "origin&Destination/index",
            meta: { title: "TradeProductDetails" },
            component: () =>
              import(
                "../views/company/TradeProduct/origin&Destination/indextwo.vue"
              ),
          },
          {
            name: "TradeProductDetailssuppliers&Buyers",
            path: "suppliers&Buyers/index",
            meta: { title: "TradeProductDetails" },
            component: () =>
              import(
                "../views/company/TradeProduct/suppliers&Buyers/index.vue"
              ),
          },
          {
            name: "TradeProductDetailsproducts",
            path: "products/index",
            meta: { title: "TradeProductDetails" },
            component: () =>
              import("../views/company/TradeProduct/products/index.vue"),
          },
          {
            name: "TradeProductDetailstradeTrends",
            path: "tradeTrends/index",
            meta: { title: "TradeProductDetails" },
            component: () =>
              import("../views/company/TradeProduct/TradeTrends/indextwo.vue"),
          },

          // creditOpinion 模块

          {
            name: "TradeProductDetailssanctionsSituation",
            path: "sanctionsSituation/list",
            meta: { title: "TradeProductDetails" },
            component: () =>
              import(
                "../views/company/TradeProduct/sanctionsSituation/index.vue"
              ),
          },
          // Market Analysis模块
        ],
      },
      // 贸易国家详情
      {
        path: "TradeCountry/TradeDetail/:id",
        component: () => import("../views/company/TradeCountryDetail.vue"),
        name: "TradeCountryDetails",
        meta: { title: "TradeCountryDetails" },
        children: [
          // background部分
          {
            name: "TradeCountryDetailstradeMap",
            path: "tradeMap/map",
            meta: { title: "TradeCountryDetails" },
            component: () =>
              import("../views/company/TradeCountry/countryData/index.vue"),

            // component: () => import('../views/company/TradeCountry/tradeMap/map.vue'),
          },
          {
            name: "TradeCountryDetailscountryData",
            path: "countryData/index",
            meta: { title: "TradeCountryDetails" },
            component: () =>
              import("../views/company/TradeCountry/countryData/indextree.vue"),
          },
          {
            name: "TradeCountryDetailscountries",
            path: "countries/index",
            meta: { title: "TradeCountryDetails" },
            component: () =>
              import("../views/company/TradeCountry/Countries/indextwo.vue"),
          },
          {
            name: "TradeCountryDetailsenterprises",
            path: "enterprises/index",
            meta: { title: "TradeCountryDetails" },
            component: () =>
              import("../views/company/TradeCountry/enterprises/index.vue"),
          },
          {
            name: "TradeCountryDetailsenterprises&Export",
            path: "enterprises/importDetailCountry",
            meta: { title: "TradeCountryDetails" },
            component: () =>
              import(
                "../views/company/TradeCountry/enterprises/importDetailCountry.vue"
              ),
          },

          {
            name: "TradeCountryDetailsproducts",
            path: "products/index",
            meta: { title: "TradeCountryDetails" },
            component: () =>
              import("../views/company/TradeCountry/products/indextwo.vue"),
          },

          {
            name: "TradeCountryDetailstradeTrends",
            path: "tradeTrends/index",
            meta: { title: "TradeCountryDetails" },
            component: () =>
              import("../views/company/TradeCountry/TradeTrends/index.vue"),
          },

          // creditOpinion 模块

          {
            name: "TradeCountryDetailscreditOpinion",
            path: "creditOpinion/list",
            meta: { title: "TradeCountryDetails" },
            component: () =>
              import("../views/company/TradeCountry/creditOpinion/list.vue"),
          },
          // Market Analysis模块
        ],
      },
      // 公司详情
      {
        path: "company/details/:id",
        component: () => import("../views/company/details.vue"),
        name: "companyDetails",
        meta: { title: "详情页面" },
        children: [
          // background部分
          {
            name: "backgroundsnapshot",
            path: "background/snapshot",
            meta: { title: "companyDetails" },
            component: () =>
              import("../views/company/details/Background/Snapshot.vue"),
          },
          {
            name: "backgroundprofile",
            path: "background/profile",
            meta: { title: "companyDetails" },
            component: () =>
              import("../views/company/details/Background/Profile.vue"),
          },
          {
            name: "backgroundownership",
            path: "background/ownership",
            meta: { title: "companyDetails" },
            component: () =>
              import("../views/company/details/Background/Ownership.vue"),
          },
          {
            name: "backgroundrelatedCompanies",
            path: "background/relatedCompanies",
            meta: { title: "companyDetails" },
            component: () =>
              import(
                "../views/company/details/Background/RelatedCompanies.vue"
              ),
          },
          {
            name: "backgroundmanagement",
            path: "background/management",
            meta: { title: "companyDetails" },
            component: () =>
              import("../views/company/details/Background/Management.vue"),
          },

          // businessActivities部分
          {
            name: "businessActivitiesoperations",
            path: "business/operations",
            meta: { title: "companyDetails" },
            component: () => import("../views/company/details/business.vue"),
          },
          {
            name: "businessActivitieslocations",
            path: "business/locations",
            meta: { title: "companyDetails" },
            component: () =>
              import(
                "../views/company/details/BusinessActivities/Locations.vue"
              ),
          },
          {
            name: "businessActivitiesindustry",
            path: "business/industry",
            meta: { title: "companyDetails" },
            component: () =>
              import(
                "../views/company/details/BusinessActivities/Industry.vue"
              ),
          },
          {
            name: "businessActivitiesimport&Export",
            path: "business/import&Export",
            meta: { title: "companyDetails" },
            component: () =>
              import(
                "../views/company/details/BusinessActivities/Import&Export.vue"
              ),
          },
          {
            name: "businessActivitiesimport&Export",
            path: "business/ImportDetail",
            meta: { title: "companyDetails" },
            component: () =>
              import(
                "../views/company/details/BusinessActivities/ImportDetail.vue"
              ),
          },
          {
            name: "businessActivitiessupplyChain",
            path: "business/supplyChain",
            meta: { title: "companyDetails" },
            component: () =>
              import(
                "../views/company/details/BusinessActivities/SupplyChain.vue"
              ),
          },

          // Performance 部分
          {
            name: "performancefinancialHighlights",
            path: "performance/financialHighlights",
            meta: { title: "companyDetails" },
            component: () =>
              import(
                "../views/company/details/Performance/FinancialHighlights.vue"
              ),
          },
          {
            name: "performanceratioAnalysis",
            path: "performance/ratioAnalysis",
            meta: { title: "companyDetails" },
            component: () =>
              import("../views/company/details/Performance/RatioAnalysis.vue"),
          },
          {
            name: "performanceindustryNorms",
            path: "performance/industryNorms",
            meta: { title: "companyDetails" },
            component: () =>
              import("../views/company/details/Performance/IndustryNorms.vue"),
          },

          // Publications 部分
          {
            name: "publicationslawsuits",
            path: "publications/lawsuits",
            meta: { title: "companyDetails" },
            component: () =>
              import("../views/company/details/Publications/Lawsuits.vue"),
          },
          {
            name: "publicationsnews",
            path: "publications/news",
            meta: { title: "companyDetails" },
            component: () =>
              import("../views/company/details/Publications/News.vue"),
          },
          {
            name: "publicationssanctions",
            path: "publications/sanctions",
            meta: { title: "companyDetails" },
            component: () =>
              import("../views/company/details/Publications/Sanctions.vue"),
          },
          // creditOpinion 模块

          {
            name: "creditOpinionlist",
            path: "creditOpinion/list",
            meta: { title: "companyDetails" },
            component: () =>
              import("../views/company/details/CreditOpinion/list.vue"),
          },
          // Market Analysis模块
          {
            name: "marketAnalysisindustryStatistics",
            path: "marketAnalysis/industryStatistics",
            meta: { title: "companyDetails" },
            component: () =>
              import(
                "../views/company/details/MarketAnalysis/topechartsCountry.vue"
              ),
          },
          {
            name: "marketAnalysisratingAnalysis",
            path: "marketAnalysis/ratingAnalysis",
            meta: { title: "companyDetails" },
            component: () =>
              import("../views/company/details/MarketAnalysis/Comparison.vue"),
          },
          {
            name: "marketAnalysiscompetitiveAnalysis",
            path: "marketAnalysis/competitiveAnalysis",
            meta: { title: "companyDetails" },
            component: () =>
              import("../views/company/details/MarketAnalysis/list.vue"),
          },
        ],
      },
      //  充值模块
      {
        path: "addCredit",
        name: "AddCredit",
        component: () => import("../views/addCreat/indextwo.vue"),
      },
      // 个人中心
      {
        path: "/account",
        name: "Account",
        component: () => import("../views/myAccount/index.vue"),
        children: [
          {
            path: "YourUsage",
            name: "YourUsage",

            meta: {
              father: "Database",
            },
            component: () =>
              import("../views/myAccount/Database/yourUsage.vue"),
          },
          {
            path: "CompaniesViewed",
            name: "CompaniesViewed",
            meta: {
              father: "Database",
            },
            component: () =>
              import("../views/myAccount/Database/Datamanagement.vue"),
          },
          {
            path: "industryAnalysis",
            name: "IndustryAnalysis",
            meta: {
              father: "Database",
            },
            component: () =>
              import("../views/myAccount/dataAnalysis/industryAnalysis.vue"),
          },
          {
            path: "enterpriseAnalysis",
            name: "EnterpriseAnalysis",
            meta: {
              father: "Database",
            },
            component: () =>
              import("../views/myAccount/dataAnalysis/enterpriseAnalysis.vue"),
          },
          {
            path: "ReprotDownloaded",
            name: "ReprotsDownloaded",
            meta: {
              father: "Database",
            },
            component: () =>
              import("../views/myAccount/Database/dataAnalysis.vue"),
          },
          {
            path: "UpdatesOrdered",
            name: "UpdatesOrdered",
            father: "Database",
            meta: {
              father: "Database",
            },
            component: () =>
              import("../views/myAccount/Database/UpdatesOrdered.vue"),
          },
          // Billing and Payment
          {
            path: "BillRecord",
            name: "BillRecord",
            meta: {
              father: "Billing",
            },
            component: () => import("../views/myAccount/Biling/BillRecord.vue"),
          },
          {
            path: "DeductionRecord",
            name: "DeductionRecord",
            meta: {
              father: "Billing",
            },
            component: () =>
              import("../views/myAccount/Biling/DeductionRecord.vue"),
          },
          {
            path: "InvoiceDownload",
            name: "InvoiceDownload",
            meta: {
              father: "Billing",
            },
            component: () =>
              import("../views/myAccount/Biling/InvoiceDownload.vue"),
          },
          {
            path: "PaymentRecord",
            name: "PaymentRecord",
            meta: {
              father: "Billing",
            },
            component: () =>
              import("../views/myAccount/Biling/PaymentRecord.vue"),
          },
          //   User Settings
          {
            path: "UserSettings",
            name: "UserSettings",
            meta: {
              father: "UserSettings",
            },
            component: () => import("../views/myAccount/UserSetting.vue"),
          },
          //Notification Message
          {
            path: "Notifications",
            name: "Notifications",
            meta: {
              father: "Notifications",
            },
            component: () =>
              import(
                "../views/myAccount/NotificationMessage/Notifications.vue"
              ),
          },
          {
            path: "Newsforyou",
            name: "Newsforyou",
            meta: {
              father: "Notifications",
            },
            component: () =>
              import("../views/myAccount/NotificationMessage/Newsforyou.vue"),
          },
          //Help Center
          {
            path: "FAQ",
            name: "FAQ",
            meta: {
              father: "Help",
            },
            component: () => import("../views/myAccount/HelpCenter/faq.vue"),
          },
          {
            path: "PrivacyPolicy",
            name: "PrivacyPolicy",
            meta: {
              father: "Help",
            },
            component: () =>
              import("../views/myAccount/HelpCenter/PrivacyPolicy.vue"),
          },
          {
            path: "Terms",
            name: "Terms",
            meta: {
              father: "Help",
            },
            component: () => import("../views/myAccount/HelpCenter/Terms.vue"),
          },
          {
            path: "Instructions",
            name: "Instructions",
            meta: {
              father: "Help",
            },
            component: () =>
              import("../views/myAccount/HelpCenter/Instructions.vue"),
          },
          {
            path: "ReportaProblem",
            name: "ReportaProblem",
            meta: {
              father: "Help",
            },
            component: () =>
              import("../views/myAccount/HelpCenter/ReportaProblem.vue"),
          },
          {
            path: "About",
            name: "About",
            meta: {
              father: "About",
            },
            component: () => import("../views/myAccount/About.vue"),
          },
          //   Organizational Manag
          {
            path: "Roles",
            name: "Roles",
            meta: {
              father: "Organizational",
            },
            component: () =>
              import("../views/myAccount/OrganizationalManagement/Roles.vue"),
          },
          {
            path: "User",
            name: "User",
            meta: {
              father: "Organizational",
            },
            component: () =>
              import("../views/myAccount/OrganizationalManagement/User.vue"),
          },
          {
            path: "UserGroup",
            name: "UserGroup",
            meta: {
              father: "Organizational",
            },
            component: () =>
              import(
                "../views/myAccount/OrganizationalManagement/UserGroup.vue"
              ),
          },
          //   Account
          {
            path: "MyAccount",
            name: "MyAccount",
            meta: {
              father: "Account",
            },
            component: () => import("../views/myAccount/Account/MyAccount.vue"),
          },
          {
            path: "ContactInformation",
            name: "ContactInformation",
            meta: {
              father: "Account",
            },
            component: () =>
              import("../views/myAccount/Account/ContactInformation.vue"),
          },
          {
            path: "AccountSecurity",
            name: "AccountSecurity",
            meta: {
              father: "Account",
            },
            component: () =>
              import("../views/myAccount/Account/AccountSecurity.vue"),
          },
        ],
      },

      // APP外链
    ],
  },
  //获客(新)
  {
    path: "/leads",
    name: "leads",
    component: NewLayout,
    hidden: true,
    children: [
      {
        path: "index",
        name: "leadsIndex",
        meta: { title: "LeadsIndex", type: "index", isNewPage: true },
        component: () => import("../views/leads/index.vue"),
      },
      // 联络挖掘
      {
        path: "contact",
        name: "Contact",
        meta: { title: "Contact", type: "list", isNewPage: true },
        component: () => import("../views/leads/detail.vue"),
      },
      // {
      //   path: "list",
      //   name: "leadsList", //riskNoParams
      //   component: () => import("../views/leads/list.vue"),
      // },
    ],
  },
  //贸易（新）
  {
    path: "/trade",
    name: "trade",
    component: NewLayout,
    hidden: true,
    children: [
      {
        path: "index",
        name: "tradeIndex",
        meta: { title: "TradeIndex", type: "index", isNewPage: true },
        component: () => import("../views/trade/index.vue"),
      },
    ],
  },
  // 风险扫描
  {
    path: "/riskScanning",
    name: "riskScanning",
    component: NewLayout,
    hidden: true,
    children: [
      // 风险扫描（新）
      {
        path: "index",
        name: "riskScanningIndex",
        meta: { title: "RiskScanningIndex", type: "list", isNewPage: true },
        component: () => import("../views/riskScanning/index.vue"),
      },
      // 风险扫描历史数据（新）
      {
        path: "history",
        name: "riskScanninghistory",
        meta: {
          title: "RiskScanningHistory",
          type: "list",
          isNewPage: true,
        },
        component: () => import("../views/riskScanning/history.vue"),
      },
    ],
  },
  // UBO
  {
    path: "/ubo",
    name: "ubo",
    component: NewLayout,
    hidden: true,
    children: [
      {
        path: "index",
        name: "uboIndex",
        meta: { title: "UboIndex", type: "index", isNewPage: true },
        component: () => import("../views/UBO/index.vue"),
      },
      {
        path: "list",
        name: "uboList",
        meta: {
          title: "UboList",
          type: "list",
          isNewPage: true,
        },
        component: () => import("../views/UBO/list.vue"),
      },
      {
        path: "detail",
        name: "uboDetail",
        meta: {
          title: "UboDetail",
          type: "list",
          isNewPage: true,
        },
        component: () => import("../views/UBO/detail.vue"),
      },
    ],
  },
  // 购买

  //个人中心

  // 新闻和制裁板块
  {
    path: "/news",
    component: NewLayout,
    hidden: true,
    children: [
      {
        path: "index",
        name: "newsIndex",
        meta: { title: "NewsIndex", type: "index", isNewPage: true },
        component: () => import("../views/news/index.vue"),
      },
      {
        path: "list",
        name: "newsList",
        meta: {
          title: "NewsList",
          type: "list",
          isNewPage: true,
          theme: "news-theme",
        },
        component: () => import("../views/news/list.vue"),
      },
    ],
  },
  //国家制裁
  //   {
  //   path: "/country",
  //   component:countryLayout,
  //   hidden: true,
  //   children: [
  //     {
  //       path: "ListRisk",
  //       name: "CountryList",
  //       meta: {
  //         title: "ListRisk",
  //         type: "list",
  //         isNewPage: true,
  //         theme: "Country-theme",
  //          theme: "sanction-theme",
  //       },
  //       component: () => import("../views/countryRisk/countryListRisk.vue"),
  //     },
  //   ],
  // },
  // 制裁
  {
    path: "/sanction",
    component: NewLayout,
    hidden: true,
    children: [
      {
        path: "index",
        name: "sanctionIndex",
        meta: { title: "SanctionIndex", type: "index", isNewPage: true },
        component: () => import("../views/sanction/index.vue"),
      },
      {
        path: "home",
        name: "sanctionHome",
        meta: {
          title: "SanctionList",
          type: "list",
          isNewPage: true,
          theme: "sanction-theme",
        },
        component: () => import("../views/sanction/home.vue"),
      },
      {
        path: "companyList",
        name: "companyList",
        meta: {
          title: "SanctionList",
          type: "list",
          isNewPage: true,
          theme: "sanction-theme",
        },
        component: () => import("../views/sanction/companyList.vue"),
      },
      {
        path: "companyDetail/:id",
        name: "companyDetail",
        meta: {
          title: "SanctionList",
          type: "list",
          isNewPage: true,
          theme: "sanction-theme",
        },
        component: () => import("../views/sanction/companyDetail.vue"),
      },
      {
        path: "personList",
        name: "personList",
        meta: {
          title: "SanctionList",
          type: "list",
          isNewPage: true,
          theme: "sanction-theme",
        },
        component: () => import("../views/sanction/personList.vue"),
      },
      {
        path: "personDetail/:id",
        name: "personDetail",
        meta: {
          title: "SanctionList",
          type: "list",
          isNewPage: true,
          theme: "sanction-theme",
        },
        component: () => import("../views/sanction/personDetail.vue"),
      },
      {
        path: "productList",
        name: "productList",
        meta: {
          title: "SanctionList",
          type: "list",
          isNewPage: true,
          theme: "sanction-theme",
        },
        component: () => import("../views/sanction/productList.vue"),
      },
      {
        path: "countryList",
        name: "countryList",
        meta: {
          title: "SanctionList",
          type: "list",
          isNewPage: true,
          theme: "sanction-theme",
        },
        // component: () => import("../views/sanction/countryList.vue"),
        component: () => import("../views/countryRisk/countryListRisk.vue"),
      },
      {
        path: "companyRiskDetail/:id",
        name: "companyRiskDetail",
        meta: {
          title: "SanctionList",
          type: "list",
          isNewPage: true,
          theme: "sanction-theme",
        },
        component: () => import("../views/countryRisk/countryRiskDetail.vue"),
      },
    ],
  },
  // 数据服务
  {
    path: "/dataServices",
    component: NewLayout,
    hidden: true,
    children: [
      {
        path: "index",
        name: "dataServicesIndex",
        meta: { title: "DataServicesIndex", type: "index", isNewPage: true },
        component: () => import("../views/dataServices/index.vue"),
      },
      {
        path: "list",
        name: "dataServicesList",
        meta: {
          title: "DataServicesList",
          isNewPage: true,
          theme: "dataServices-theme",
          menuGroup: "dataServicesList",
        },
        component: () => import("../views/dataServices/list.vue"),
      },
      {
        path: "dataCleaning",
        name: "dataCleaning",
        meta: {
          title: "DataCleaning",
          isNewPage: true,
          theme: "dataServices-theme",
          menuGroup: "dataCleaning",
        },
        component: () =>
          import("../views/dataServices/dataCleaning/dataCleaning.vue"),
      },
      {
        path: "dataApi",
        name: "dataApi",
        meta: {
          title: "DataApi",
          isNewPage: true,
          theme: "dataServices-theme",
          menuGroup: "dataApi", //用于在每个子页面选中顶部导航栏
        },
        redirect: { name: "APIHomepage" },
        component: () => import("../views/dataServices/dataApi/dataApi.vue"),
        children: [
          {
            path: "APIHomepage",
            name: "APIHomepage",
            meta: {
              title: "APIHomepage",
              isNewPage: true,
              theme: "dataServices-theme",
              menuGroup: "dataApi",
            },
            component: () =>
              import("../views/dataServices/dataApi/APIHomepage.vue"),
          },
          {
            path: "APIHomepage_more",
            name: "APIHomepage_more",
            meta: {
              title: "APIHomepage_more",
              isNewPage: true,
              theme: "dataServices-theme",
              menuGroup: "dataApi",
            },
            component: () =>
              import("../views/dataServices/dataApi/APIHomepage_more.vue"),
          },
          {
            path: "APIHomepage_more_detail",
            name: "APIHomepage_more_detail",
            meta: {
              title: "APIHomepage_more_detail",
              isNewPage: true,
              theme: "dataServices-theme",
              menuGroup: "dataApi",
            },
            component: () =>
              import(
                "../views/dataServices/dataApi/APIHomepage_more_detail.vue"
              ),
          },
          {
            path: "AccountManagement",
            name: "AccountManagement",
            meta: {
              title: "AccountManagement",
              isNewPage: true,
              theme: "dataServices-theme",
              menuGroup: "dataApi",
            },
            component: () =>
              import("../views/dataServices/dataApi/AccountManagement.vue"),
          },
          {
            path: "Test",
            name: "Test",
            meta: {
              title: "Test",
              isNewPage: true,
              theme: "dataServices-theme",
              menuGroup: "dataApi",
            },
            component: () => import("../views/dataServices/dataApi/Test.vue"),
          },
          {
            path: "TestRecords",
            name: "TestRecords",
            meta: {
              title: "TestRecords",
              isNewPage: true,
              theme: "dataServices-theme",
              menuGroup: "dataApi",
            },
            component: () =>
              import("../views/dataServices/dataApi/TestRecords.vue"),
          },
        ],
      },

      {
        path: "bulkData",
        name: "bulkData",
        meta: {
          title: "BulkData",
          isNewPage: true,
          theme: "dataServices-theme",
          menuGroup: "bulkData",
        },
        component: () => import("../views/dataServices/bulkData/bulkData.vue"),
      },
      {
        path: "dataLibrary",
        name: "dataLibrary",
        meta: {
          title: "DataLibrary",
          isNewPage: true,
          theme: "dataServices-theme",
          menuGroup: "dataLibrary",
        },
        redirect: { name: "apiDocumentation" },
        component: () =>
          import("../views/dataServices/dataLibrary/dataLibrary.vue"),
        children: [
          {
            path: "apiDocumentation",
            name: "apiDocumentation",
            meta: {
              title: "ApiDocumentation",
              isNewPage: true,
              theme: "dataServices-theme",
              menuGroup: "dataLibrary",
            },
            component: () =>
              import("../views/dataServices/dataLibrary/apiDocumentation.vue"),
          },
          {
            path: "apiDocumentationDetail",
            name: "apiDocumentationDetail",
            meta: {
              title: "ApiDocumentationDetail",
              isNewPage: true,
              theme: "dataServices-theme",
              menuGroup: "dataLibrary",
            },
            component: () =>
              import(
                "../views/dataServices/dataLibrary/apiDocumentationDetail.vue"
              ),
          },
          {
            path: "dataDictionary",
            name: "dataDictionary",
            meta: {
              title: "DataDictionary",
              isNewPage: true,
              theme: "dataServices-theme",
              menuGroup: "dataLibrary",
            },
            component: () =>
              import("../views/dataServices/dataLibrary/dataDictionary.vue"),
          },
          {
            path: "dataDictionaryDetail",
            name: "dataDictionaryDetail",
            meta: {
              title: "DtaDictionaryDetail",
              isNewPage: true,
              theme: "dataServices-theme",
              menuGroup: "dataLibrary",
            },
            component: () =>
              import(
                "../views/dataServices/dataLibrary/dataDictionaryDetail.vue"
              ),
          },
          {
            path: "websiteNavigation",
            name: "websiteNavigation",
            meta: {
              title: "WbsiteNavigation",
              isNewPage: true,
              theme: "dataServices-theme",
              menuGroup: "dataLibrary",
            },
            component: () =>
              import("../views/dataServices/dataLibrary/websiteNavigation.vue"),
          },
          {
            path: "websiteNavigationDetail",
            name: "websiteNavigationDetail",
            meta: {
              title: "WebsiteNavigationDetail",
              isNewPage: true,
              theme: "dataServices-theme",
              menuGroup: "dataLibrary",
            },
            component: () =>
              import(
                "../views/dataServices/dataLibrary/websiteNavigationDetail.vue"
              ),
          },
        ],
      },
      {
        path: "customizePlan",
        name: "customizePlan",
        meta: {
          title: "CustomizePlan",
          isNewPage: true,
          theme: "dataServices-theme",
          menuGroup: "customizePlan",
        },
        component: () =>
          import("../views/dataServices/customizePlan/customizePlan.vue"),
      },
    ],
  },
];

export default routes;
//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push;
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
